import gql from 'graphql-tag';

const SEARCH_ORGS = gql`
  query searchOrgs($parentid: ID!, $searchTerm: String!, $first: Int) {
    orgs(
      first: $first
      where: {
        AND: [
          { OR: [{ parentOrg_some: { id: $parentid } }, { id: $parentid }] }
          { name_contains: $searchTerm }
        ]
      }
      orderBy: name_ASC
    ) {
      id
      name
      parentOrg {
        id
        name
        level
      }
      config {
        isAdmin
      }
      roles(first: 1, where: { isMaster: true }) {
        id
        isMaster
        roleItems(first: 15) {
          id
          feature
          actions
        }
      }
    }
  }
`;

export default SEARCH_ORGS;
